import Cookie from 'js-cookie';

const initUserInfo = () => {
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(userInfoContext.dataLayerLoad);
  });

  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    let flashMessages = userInfoContext.flashMessages;
    let cssType = {'success': 'success', 'info': 'info', 'warning': 'primary', 'error': 'danger'};
    let iconType = {'success': 'check-circle', 'info': 'info-circle', 'warning': 'info-circle', 'error': 'exclamation-circle'};
    let hasFlashMessage = Object.keys(flashMessages).length > 0;
    let each = function (c, f) {
      for (let k in c) {
        if (c.hasOwnProperty(k)) {
          f(c[k], k);
        }
      }
    };

    const renderFlashMessage = function (elContainer, flashMessages) {
      let html = elContainer.innerHTML;
      each(flashMessages, function (messages, type) {
        each(messages, function (message) {
          html += `<div class="alert alert-${cssType[type]} alert-dismissible alert-icon-prefixed" role="alert">
                        <div class="alert-icon">
                            <i class="fa fa-${iconType[type]}"></i>
                        </div>
                        <div class="alert-content">${message}</div>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="fa fa-close" aria-hidden="true"></i></button>
                    </div>`;
        });
      });

      elContainer.innerHTML = html;
    };
    let elContainer = document.getElementById('flash-message-container');
    if (null !== elContainer) {
      renderFlashMessage(elContainer, flashMessages);
      if (sessionStorage && sessionStorage.getItem('flashMessages')) {
        renderFlashMessage(elContainer, JSON.parse(sessionStorage.getItem('flashMessages')));
        sessionStorage.removeItem('flashMessages');
      }
    } else if (hasFlashMessage) {
      if (sessionStorage && typeof (sessionStorage.setItem) === 'function') {
        if (console && console.log) {
          console.log('no #flash-message-container found, store flash message into session storage for next page rendering');
        }
        sessionStorage.setItem('flashMessages', JSON.stringify(flashMessages));
      }
    }
  });

  /* topbar top right postcode status */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    let elLocation = document.getElementById('user-menu-location');

    if (null === elLocation) {
      return;
    }

    if (userInfoContext.htmlHeaderTopbarPostcodeWithWeather) {
      elLocation.innerHTML = userInfoContext.htmlHeaderTopbarPostcodeWithWeather;
    } else if (userInfoContext.htmlHeaderTopbarPostcode) {
      elLocation.innerHTML = userInfoContext.htmlHeaderTopbarPostcode;
    }
  });

  /* topbar top right user info status */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    /* if this block exists, also means user is not null */
    if (userInfoContext.htmlHeaderTopbarAccount) {
      let el = document.getElementById('user-menu-account');
      if (el) {
        el.innerHTML = userInfoContext.htmlHeaderTopbarAccount;
      }
    }
  });

  /* topbar top right cart full or empty */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    if (!userInfoContext.cartIsEmpty) {
      let els = document.querySelectorAll('.panier-empty,.panier-empty-white');
      for (let i = 0; i < els.length; i++) {
        els[i].className = els[i].className.replace('panier-empty', 'panier-full');
      }
    }
  });

  /* postcode popup: newsletter email */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    let el;
    if (userInfoContext.user || userInfoContext.townEmail) {
      el = document.getElementById('postcode-popup-form-row-email');
      if (el) {
        el.parentNode.removeChild(el);
      }
    }

    if (userInfoContext.user) {
      el = document.getElementById('postcode-popup-form-login');
      if (!el) {
        el.style.display = '';
      }
    }
  });

  /* footer newsletter form */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    let el = document.getElementById('footer-newsletter-form-token');
    if (el) {
      (el as HTMLInputElement).value = userInfoContext.footerNewsletterFormToken;
    }

    el = document.getElementById('footer-newsletter-form-redirect');
    if (el) {
      (el as HTMLInputElement).value = window.location.pathname;
    }

    el = document.getElementById('footer-newsletter-form-email');
    if (el) {
      if (userInfoContext.townEmail) {
        (el as HTMLInputElement).value = userInfoContext.townEmail;
      } else if (userInfoContext.user && userInfoContext.user.email) {
        (el as HTMLInputElement).value = userInfoContext.user.email;
      }
    }
  });

  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    if (!userInfoContext.htmlCountryProposal) {
      return;
    }

    let elCountryProposal = document.getElementById('country-proposal');
    if (!elCountryProposal) {
      return;
    }

    elCountryProposal.outerHTML = userInfoContext.htmlCountryProposal;
    // because outerHTML will detach previous elCountryProposal, we need re-fetch here
    elCountryProposal = document.getElementById('country-proposal');

    const cookiePrefix = 'country_proposal_';
    const cookieName = cookiePrefix + elCountryProposal.getAttribute('data-locale');
    if (Cookie.get(cookieName) !== '1') {
      elCountryProposal.style.display = 'inherit';
    }
    const btnClose = elCountryProposal.querySelector('.close');
    if (btnClose) {
      btnClose.addEventListener('click', function (e) {
        Cookie.set(cookieName, '1', {expires: 1});
        elCountryProposal.style.display = 'none';
      });
    }
  });

  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    function extractLinks(elScript) {
      let data = JSON.parse(elScript.innerHTML);
      let links = [];
      for (let j = 0; j < userInfoContext.toolbarAdminLinks.length; j++) {
        let objLink = userInfoContext.toolbarAdminLinks[j];
        let htmlLink = '<a href="' + objLink.url + '" target="_blank">' + objLink.label + '</a>';
        let valid = true;
        for (let tag in objLink.parameterMap) if (objLink.parameterMap.hasOwnProperty(tag)) {
          let ref = objLink.parameterMap[tag];
          if (!data[ref]) {
            valid = false;
            break;
          }
          htmlLink = htmlLink.replace(new RegExp(tag, 'g'), data[ref]);
        }
        if (valid) {
          links.push(htmlLink);
        }
      }
      return links;
    }

    if (userInfoContext.htmlToolbarAdmin) {
      // if we enter here, means we has at least ROLE_ADMIN
      let elAdminToolbar = document.createElement('div');
      elAdminToolbar.innerHTML = userInfoContext.htmlToolbarAdmin;
      let body = document.body;
      body.insertBefore(elAdminToolbar, body.firstChild);

      (function (elScripts) {
        for (let i = 0; i < elScripts.length; i++) {
          let elDiv = document.createElement('div');
          elDiv.className = 'wysiwyg text-center js-admin-inline-link';
          elDiv.innerHTML = extractLinks(elScripts[i]).join('<br />');
          elScripts[i].parentNode.replaceChild(elDiv, elScripts[i]);
        }
      })(document.querySelectorAll('script.js-admin-inline-link'));

      (function (elScripts, elMenuPimUl) {
        if (!elMenuPimUl) {
          return [];
        }
        let first = true;
        for (let i = 0; i < elScripts.length; i++) {
          let links = extractLinks(elScripts[i]);
          for (let j = 0; j < links.length; j++) {
            // clear menu content
            if (first) {
              elMenuPimUl.innerHTML = '';
              first = false;
            }
            let elLi = document.createElement('li');
            elLi.innerHTML = links[j];
            elMenuPimUl.appendChild(elLi);
          }
        }
      })(document.querySelectorAll('script.js-admin-toolbar-link'), document.querySelector('#header-toolbar-admin-menu-pim > ul'));
    }
  });

  /* Cookie consent */
  window.onUserInfoLoad.push(function (/** @var {UserInfoContext} */userInfoContext) {
    if (userInfoContext.cookieConsent) {
      let s = document.createElement('script');
      s.src = userInfoContext.cookieConsent['src'];
      s.async = true;
      console.log(s.src);
      document.head.appendChild(s);
      window.cookieconsent_options = userInfoContext.cookieConsent['options'];
    }
  });
};

export default initUserInfo;
